var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNotificacao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notifica\\xE7\\xF5es",
    transform: "translate(-69.16 -39.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1012",
    transform: "translate(74.161 44.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.9,16V9.5c0-7.7-6.2-13.9-13.9-13.9C5.3-4.4-0.9,1.8-0.9,9.5l0,0V16l-3.2,4.8c-0.5,0.8-0.3,1.9,0.5,2.4 c0.3,0.2,0.6,0.3,1,0.3h31.4c1,0,1.7-0.8,1.7-1.7c0-0.3-0.1-0.7-0.3-1l0,0L26.9,16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    d: "M17.3,29c1.2-0.9,2.1-2.3,2.5-3.8H6.3C6.6,26.7,7.5,28,8.7,29c1.2,0.9,2.7,1.5,4.3,1.5l0,0 C14.5,30.4,16,29.9,17.3,29z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificacao01);
export default __webpack_public_path__ + "static/media/ico-notificacao-01.4632ec444772a6c5aa704e783efcf0f9.svg";
export { ForwardRef as ReactComponent };